import { useState, useMemo } from 'react';
import "./Triads.css"
import MusicIntervalCard from "./MusicIntervalCard.js";

function Triads() {
    // Define the cards and shuffle them
    const shuffledCards = useMemo(() => {        
        const intervalList = [
            "A minor", "A major", "Bb minor", "Bb major", "B minor", "B major", "C minor", "C major", "Db minor", "Db major", "D minor", "D major",
            "Eb minor", "Eb major", "E minor", "E major", "F minor", "F major", "Gb minor", "Gb major", "G minor", "G major", "Ab minor", "Ab major"
        ];
        return intervalList.sort(() => Math.random() - .5);
    }, []);
    // Track which cards have been selected by the players.
    const [cardTracker, setCardTracker ] = useState(() => {
        const cardStatus = [];
        shuffledCards.forEach((card) => {cardStatus.push({ "cardName" : card, "selected" : false, "chord" : 0, "chordSlot" : 0})}) 
        return cardStatus;
    });

    // Track how many players will be playing.
    const [ playersSelected, setPlayersSelected] = useState(0);
    const updatePlayersSelected = (choice) => {
        setPlayersSelected(+choice);
    }

    // This variable is used to map the cards to the players
    const [playerCardList, setPlayerCardList] = useState(() => 
        Array.from({ length: 12 }, (_, index) => ({
            player: index + 1,
            name: index + 1,
            slot1: 'empty',
            slot2: 'empty',
            count: 0
        }))
    );

    // Track which player is selected while picking cards
    const [ currentPlayer, setCurrentPlayer ] = useState(1);

    // When a card is selected by the currentPlayer, track the selection and the slot.
    const selectCard = (player, id) => {
        setPlayerCardList(prevList => 
            prevList.map(item => {
                if (item.player === player) {
                    if (item.slot1 === 'empty' && !cardTracker[id].selected) {
                        setCardTracker(prevList => 
                            prevList.map((item, index) => {
                                if (index === id) {
                                    return { 
                                        ...item,
                                        cardName : item.cardName, 
                                        selected : true
                                    };
                                }
                                return item
                            })
                        )
                        return { 
                            ...item, 
                            slot1: id, 
                            count: item.count + 1 
                        };
                    } else if (item.slot2 === 'empty' && !cardTracker[id].selected) {
                        setCardTracker(prevList => 
                            prevList.map((item, index) => {
                                if (index === id) {
                                    return {
                                        ...item,
                                        cardName : item.cardName,
                                        selected : true
                                    };
                                }
                                return item
                            })
                        )
                        return { 
                            ...item, 
                            slot2: id, 
                            count: item.count + 1 
                        };
                    }
                }
                return item;
            })
        );
    };

    // Create an array by searching through the cardTracker for cards that have been assigned to chords.
    const chordCards = useMemo(() => {
        const chords = Array.from({ length: playersSelected * 2 }, (_, index) => ({
            chord: index + 1,
            name: "none",
            slot1: 'empty',
            slot2: 'empty',
            count: 0
        }));
        cardTracker.forEach((card) => {
            if (card.chord > 0 ) {
                if (card.slot1 > 0) {chords[card.chord - 1].slot1 = card.cardName}
                if (card.slot2 > 0) {chords[card.chord - 1].slot2 = card.cardName}
            }
        })
        return chords;
    }, [cardTracker, playersSelected]);

    // Determine when all players have picked their cards.
    const cardSelectionComplete = useMemo(() => {
        let counter = 0;
        cardTracker.forEach((card) => {
            if (card.selected) {
                ++counter;
            }
        });
        if((counter < 2 * playersSelected) || (playersSelected === 0)) {
            return false
        }
        return true
    }, [cardTracker, playersSelected]);

    const [ currentPlayerCard, setCurrentPlayerCard ] = useState({ "player" : "empty", "slot" : "empty"});

    // Track which chord is selected to add cards to.
    const [ currentChord, setCurrentChord ] = useState(1);

    // Update the player card currently selected
    const selectPlayerCard = (player, slot) => {
        const activePlayerCard = (slot === 1) ? cardTracker[playerCardList.find(item => item.player === player ).slot1].cardName : cardTracker[playerCardList.find(item => item.player === player ).slot2].cardName;
        setCurrentPlayerCard({ "player" : player, "slot" : slot, "interval" : activePlayerCard });
    };

    // Add selected player card to the selected chord slot
    const addCard2Chord = (chord, slot, interval ) => {
        console.log("chord", chord, "slot",  slot, "interval",  interval);
        setCardTracker((prevList) => {
            prevList.map((card) => {
                if (card.cardName === interval) {
                    console.log("item matches selection", card);
                    return {
                        ...card,
                        chord : chord,
                        chordSlot : slot
                    }
                }
                // console.log("item doesn't match selection", item);
                return card
            });
        });
    }
    
    return <div>
        <h1>TRIADS</h1>
        <h2>A Musical Composition Game of Chance</h2>
        {(playersSelected === 0) && <div className="playersSelection">
            <h3>Select The Number of Players</h3>
            <select id="numOfPlayers" value={playersSelected} onChange={(e) => updatePlayersSelected(e.target.value)}>
                <option value="0"> </option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
            </select>
        </div>}
        <div className="cardTableauContainer">
            {(playersSelected !== 0) && <div className="cardTableau">
                {cardTracker.map((card, index) => 
                    <div key={index} className="musicCard" onClick={() => selectCard(currentPlayer, index)}>
                        <MusicIntervalCard interval={card.cardName} visibility="Show" restricted={card.selected}/>
                    </div>
                )}
            </div>}            
        </div>
        <div className="playerBoard">
            {(playersSelected !== 0) && <div className="playerButtons">
                {<button onClick={() => setCurrentPlayer(1)} style={{ opacity: (currentPlayer === 1) ? "50%" : "100%" }}>Player 1</button>}
                {<button onClick={() => setCurrentPlayer(2)} style={{ opacity: (currentPlayer === 2) ? "50%" : "100%" }}>Player 2</button>}
                {(playersSelected > 2) && <button onClick={() => setCurrentPlayer(3)} style={{ opacity: (currentPlayer === 3) ? "50%" : "100%" }}>Player 3</button>}
                {(playersSelected > 3) && <button onClick={() => setCurrentPlayer(4)} style={{ opacity: (currentPlayer === 4) ? "50%" : "100%" }}>Player 4</button>}
                {(playersSelected > 4) && <button onClick={() => setCurrentPlayer(5)} style={{ opacity: (currentPlayer === 5) ? "50%" : "100%" }}>Player 5</button>}
                {(playersSelected > 5) && <button onClick={() => setCurrentPlayer(6)} style={{ opacity: (currentPlayer === 6) ? "50%" : "100%" }}>Player 6</button>}
                {(playersSelected > 6) && <button onClick={() => setCurrentPlayer(7)} style={{ opacity: (currentPlayer === 7) ? "50%" : "100%" }}>Player 7</button>}
                {(playersSelected > 7) && <button onClick={() => setCurrentPlayer(8)} style={{ opacity: (currentPlayer === 8) ? "50%" : "100%" }}>Player 8</button>}
                {(playersSelected > 8) && <button onClick={() => setCurrentPlayer(9)} style={{ opacity: (currentPlayer === 9) ? "50%" : "100%" }}>Player 9</button>}
                {(playersSelected > 9) && <button onClick={() => setCurrentPlayer(10)} style={{ opacity: (currentPlayer === 10) ? "50%" : "100%" }}>Player 10</button>}
                {(playersSelected > 10) && <button onClick={() => setCurrentPlayer(11)} style={{ opacity: (currentPlayer === 11) ? "50%" : "100%" }}>Player 11</button>}
                {(playersSelected > 11) && <button onClick={() => setCurrentPlayer(12)} style={{ opacity: (currentPlayer === 12) ? "50%" : "100%" }}>Player 12</button>}
            </div>}
            {(playersSelected !== 0) && <>
                <h1>Player Cards</h1>
                <div className="playersArea">
                    <div className="playerDisplay">                
                        {playerCardList.map((item, index) => <div key={index}>
                            {(index < playersSelected) && <div className="playerCards">
                                <h2>Player {item.player} Cards</h2>
                                {(item.slot1 !== 'empty') && <div onClick={() => selectPlayerCard(item.player, 1)}><MusicIntervalCard interval={cardTracker[item.slot1].cardName} visibility="Show" restricted={(currentPlayerCard.player === item.player) && (currentPlayerCard.slot === 1)}/></div>}
                                {(item.slot2 !== 'empty') && <div onClick={() => selectPlayerCard(item.player, 2)}><MusicIntervalCard interval={cardTracker[item.slot2].cardName} visibility="Show" restricted={(currentPlayerCard.player === item.player) && (currentPlayerCard.slot === 2)}/></div>}
                            </div>}
                        </div>)}
                    </div>
                </div>
            </>}
            {(cardSelectionComplete) && <div className="chordButtons">
                {<button onClick={() => setCurrentChord(1)} style={{ opacity: (currentChord === 1) ? "50%" : "100%" }}>Chord 1</button>}
                {<button onClick={() => setCurrentChord(2)} style={{ opacity: (currentChord === 2) ? "50%" : "100%" }}>Chord 2</button>}
                {(playersSelected > 2) && <button onClick={() => setCurrentChord(3)} style={{ opacity: (currentChord === 3) ? "50%" : "100%" }}>Chord 3</button>}
                {(playersSelected > 3) && <button onClick={() => setCurrentChord(4)} style={{ opacity: (currentChord === 4) ? "50%" : "100%" }}>Chord 4</button>}
                {(playersSelected > 4) && <button onClick={() => setCurrentChord(5)} style={{ opacity: (currentChord === 5) ? "50%" : "100%" }}>Chord 5</button>}
                {(playersSelected > 5) && <button onClick={() => setCurrentChord(6)} style={{ opacity: (currentChord === 6) ? "50%" : "100%" }}>Chord 6</button>}
                {(playersSelected > 6) && <button onClick={() => setCurrentChord(7)} style={{ opacity: (currentChord === 7) ? "50%" : "100%" }}>Chord 7</button>}
                {(playersSelected > 7) && <button onClick={() => setCurrentChord(8)} style={{ opacity: (currentChord === 8) ? "50%" : "100%" }}>Chord 8</button>}
                {(playersSelected > 8) && <button onClick={() => setCurrentChord(9)} style={{ opacity: (currentChord === 9) ? "50%" : "100%" }}>Chord 9</button>}
                {(playersSelected > 9) && <button onClick={() => setCurrentChord(10)} style={{ opacity: (currentChord === 10) ? "50%" : "100%" }}>Chord 10</button>}
                {(playersSelected > 10) && <button onClick={() => setCurrentChord(11)} style={{ opacity: (currentChord === 11) ? "50%" : "100%" }}>Chord 11</button>}
                {(playersSelected > 11) && <button onClick={() => setCurrentChord(12)} style={{ opacity: (currentChord === 12) ? "50%" : "100%" }}>Chord 12</button>}
            </div>}
            {(cardSelectionComplete) && <>
                    <h1>Chord Construction</h1>
                <div className="chordConstructionArea">
                    <div className="chordDisplay">             
                        {chordCards.map((item, index) => <div key={index}>
                            {(index < playersSelected) && <div className="chords">
                                <h2>Chord {item.chord} </h2>
                                <div onClick={() => addCard2Chord(item.chord, 1, currentPlayerCard.interval)}><MusicIntervalCard interval={item.slot1} visibility={(item.slot1 === "empty" ? "Hide" : "Show")} restricted={false}/></div>
                                <div onClick={() => addCard2Chord(item.chord, 2, currentPlayerCard.interval)}><MusicIntervalCard interval={item.slot2} visibility={(item.slot2 === "empty" ? "Hide" : "Show")} restricted={false}/></div>
                            </div>}
                        </div>)}
                    </div>
                </div>
            </>}
        </div>
    </div>
}

export default Triads